import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';

@Component({
  selector: 'app-app-validate',
  templateUrl: './app-validate.component.html',
  styleUrls: ['./app-validate.component.scss'],
  standalone: true,
  imports: [RouterOutlet],
})
export class AppValidateComponent {}
